module.exports = __webpack_public_path__ + "img/img_company_opinion2.6fc032db.svg";